import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandLogosComponent } from './brand-logos.component';
import { BrandLogosService } from "./brand-logos.service";
import { Ng2PaginationModule } from "ng2-pagination";
import { SharedModule } from "../shared/shared.module";
import { ReactiveFormsModule } from "@angular/forms";
import { CustomFormsModule } from "ng2-validation/dist";
import { BrandLogoModalComponent } from "./brand-logo-modal.component";
import { FormHelperService } from "../core/services/form-helper.service";
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';

@NgModule({
      imports: [CommonModule, SharedModule, Ng2PaginationModule, ReactiveFormsModule, CustomFormsModule, Ng2AutoCompleteModule],
      exports: [],
      declarations: [BrandLogosComponent, BrandLogoModalComponent],
      providers: [BrandLogosService, FormHelperService],
  })
export class BrandLogosModule { }



// WEBPACK FOOTER //
// ./src/app/brand-logos/brand-logos.module.ts